import en from './en.json'
import ru from './ru.json'

export default {
  ru: Object.assign(ru),
  en: Object.assign(en)
}
